export default "__VITE_ASSET__DHsj4SI9__"